import { Component, Inject  } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


const users: string[] = [
  "ryan.hill",
  "User.Test2",
  "User.Test3",
  "User.Test4",
  "User.Test5",
  "User.Test6",
  "User.Test7",
  "User.Test8",
  "User.Test9",
  "User.Test10",
  "User.Test11",
  "User.Test12",
  "User.Test13",
  "User.Test14",
];





/**
 * @title Injecting data when opening a dialog
 */
@Component({
  selector: 'cradle-to-grave-pop-up.component',
  templateUrl: 'cradle-to-grave-pop-up.component.html',
  styleUrls: ['./cradle-to-grave-pop-up.component.css']
})
export class CradleToGravePopUpComponent {

  telepoCdrs: any[] = null;
  displayedColumns: string[] = null;


  typeLookup = {
    1: 'OUTGOING',
    2: 'INCOMING',
    3: "DIVERSION",
    4: "TRANSFER",
    6: "PICKED_UP",
    8: "CALLBACK",
    9: "TRANSFERRED",
    10: "PICK_UP",
    11: "CONTINUATION"
  };



  resultLookup = {
    1: 'BLOCKED',
    2: 'ANSWERED',
    3: "MISSED",
    4: "USER_NOT_FOUND",
    5: "DECLINED",
    6: "BUSY",
    7: "CANCELLED",
    8: "SIP_FAILURE",
    9: "ISDN_FAILURE",
    10: "OTHER_FAILURE",
    11: "INCOMPLETE",
    12: "QUEUED",
    13: "ANSWERED_BY_OTHER",
    14: "DIVERTED",
    15: "CLOSED",
    16: "CALLBACK_REQUESTED"
  };



  constructor(@Inject(MAT_DIALOG_DATA) public data: any[]) {
    this.telepoCdrs = data;

    this.displayedColumns = Object.keys(this.telepoCdrs[0]);
    
  }

  ngOnInit() {
    //const query = Object.assign({}, this.query, {});
    //
    //this.userArray = this.graphQlService.getGraphQlResults(query);
    //alert(this.userArray);

  
  }


  
}
